import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useRemoveQueryParams } from 'js/hooks/navigate';

import * as pas from '../pas';
import * as actions from '../store/actions';
import { useLoginRequest } from './useLoginRequest';
import { useAfterLoginAction } from './useAfterLoginAction';
import { useBeforeLoginAction } from './useBeforeLoginAction';
import { useFailedLoginAction } from './useFailedLoginAction';
import { useSuccessLoginAction } from './useSuccessLoginAction';
import { useGetWaitingMessages } from './useGetWaitingMessages';
import { useLoginBySessionToken } from './useLoginBySessionToken';
import { useRedirectToAfterLoginURL } from './useRedirectToAfterLoginURL';

export const useLoginByGetParams = () => {
    const removeQueryParams = useRemoveQueryParams();
    const dispatch = useDispatch();
    const { languageCode } = useLoginRequest() || {};
    const beforeLoginAction = useBeforeLoginAction();
    const loginBySessionToken = useLoginBySessionToken();
    const afterLoginAction = useAfterLoginAction();
    const successLoginAction = useSuccessLoginAction();
    const failedLoginAction = useFailedLoginAction();
    const redirectToAfterLoginURL = useRedirectToAfterLoginURL();
    const getWaitingMessages = useGetWaitingMessages();

    return useCallback(async (userName, tempToken) => {
        dispatch(actions.setIsLoginInProcess(true));
        beforeLoginAction();

        removeQueryParams(['username', 'temptoken']);

        try {
            await pas.setLoginType('SESSION_TOKEN');

            const pasLoginResponse = await pas.login({ userName, password: tempToken, languageCode });
            const { username, sessionToken: { sessionToken } = {} } = pasLoginResponse?.data || {};

            await loginBySessionToken(username, sessionToken);
            await afterLoginAction();
            await successLoginAction({ userName: username, authType: 'token' });

            await getWaitingMessages();

            redirectToAfterLoginURL();
        } catch (error) {
            failedLoginAction(error);
        } finally {
            dispatch(actions.setIsLoginInProcess(false));
            dispatch(actions.setAutoLoginCompleted());
        }
    }, [
        languageCode, removeQueryParams, dispatch, getWaitingMessages,
        loginBySessionToken, beforeLoginAction, afterLoginAction,
        successLoginAction, failedLoginAction, redirectToAfterLoginURL
    ]);
};
